import { useEffect, useRef, useState } from "react";
import { logAction } from "../api/logApi";
import { call, register, remove } from "../funcStore";
import TagList from "./TagList";

const styles = {
  profileSection: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    display: "flex",
    gap: "16px",
  },
  profileIcon: {
    width: "96px",
    height: "96px",
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
  },
};

function VTuberProfile({ vtuber }) {
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_DISPLAY = "display";

  const [state, setState] = useState(STATE_BEFORE_INIT);

  const stateRef = useRef(state);
  stateRef.current = state;

  const funcKeyRef = useRef("vtuberProfile");
  const funcKey = funcKeyRef.current;

  const dataRef = useRef({ clickedTag: "" });

  function getClickTag() {
    const tag = dataRef.current.clickedTag;
    dataRef.current.clickedTag = "";
    return tag;
  }

  function setClickTag(tag) {
    logAction("tag_click", { tag });
    dataRef.current.clickedTag = tag;
    call("app.navigateToSearch");
  }

  function init() {
    register(`${funcKey}.getClickTag`, getClickTag);
    register(`${funcKey}.getAttributes`, () => vtuber.attributes);
    register(`${funcKey}.tagClick`, setClickTag);

    setState(STATE_DISPLAY);
  }

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    return () => {
      remove(`${funcKey}.getAttributes`);
      remove(`${funcKey}.tagClick`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  return (
    <section style={styles.profileSection}>
      <img style={styles.profileIcon} src={vtuber.iconUrl} alt={vtuber.name} />
      <div>
        <h2>{vtuber.name}</h2>
        <p>{vtuber.description}</p>
        <p>登録者数: {vtuber.subscriberCount.toLocaleString()}人</p>
        <a
          href={vtuber.youtubeUrl}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            logAction("channel_link_click", { vtuberId: vtuber.id })
          }
        >
          YouTubeチャンネルを見る
        </a>
        <TagList parentKey={funcKey} />
      </div>
    </section>
  );
}

export default VTuberProfile;
